<!--Modal-->
<div class="col-md-12">

<div class="row">

  <form ngNativeValidate [formGroup]="forma" method="post" id="form-ui">

      <div class="col-md-2">

        <mat-form-field class="example-full-width">
          <mat-label>From Date</mat-label>
          <input matInput [matDatepicker]="pickerdos" formControlName="dateto" name="datedelivery">
          <mat-datepicker-toggle matSuffix [for]="pickerdos"></mat-datepicker-toggle>
          <mat-datepicker  #pickerdos color="primary"></mat-datepicker>
        </mat-form-field>

      </div>
      <div class="col-md-2">
        <mat-form-field class="example-full-width">
          <mat-label>To Date</mat-label>
          <input matInput [matDatepicker]="pickertres" formControlName="datefrom" name="datedelivery">
          <mat-datepicker-toggle matSuffix [for]="pickertres"></mat-datepicker-toggle>
          <mat-datepicker  #pickertres color="primary"></mat-datepicker>
        </mat-form-field>

      </div>
      <div class="col-md-4">

        <button class="btn btn-primary" [disabled]="forma.invalid" (click)="searchByDate()"> <i class="fa fa-search"></i> Search </button>

          <button class="btn btn-success" style="margin-left: 5px;" (click)="searchAllOrders()"> <i class="fa fa-search"></i> All Orders </button>

      </div>


      <div class="col-md-4">
        <mat-form-field>
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium">
      </mat-form-field>

      </div>

    </form>


</div>





  <div class="mat-elevation-z8" style="margin-top: 10px">

      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">




          <!-- Position Column -->
          <ng-container matColumnDef="company">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Company Name </th>
              <td mat-cell *matCellDef="let element"> {{element.companyname}} </td>
          </ng-container>



          <!-- Name Column -->
          <ng-container matColumnDef="firstname">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Contact name </th>
              <td mat-cell *matCellDef="let element"> {{element.firstnamecontact}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="lastname">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Contact lastname </th>
              <td mat-cell *matCellDef="let element"> {{element.lastnamecontact}} </td>
          </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="distance">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Distance </th>
                <td mat-cell *matCellDef="let element"> {{element.distance}} </td>
            </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="time">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Time </th>
                    <td mat-cell *matCellDef="let element"> {{element.time}} </td>
                </ng-container>

                        <!-- Weight Column -->
                        <ng-container matColumnDef="total">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Total </th>
                          <td mat-cell *matCellDef="let element"> {{element.total}} $ </td>
                      </ng-container>

                               <!-- Weight Column -->
                               <ng-container matColumnDef="datedelivery">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date delivery </th>
                                <td mat-cell *matCellDef="let element"> {{ element.datedelivery | date: 'dd/MM/yyyy' }}  </td>
                            </ng-container>


           <!-- Symbol Column -->
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Phone </th>
            <td mat-cell *matCellDef="let element"> {{element.phone}} </td>
        </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
              <td mat-cell *matCellDef="let element"> {{element.email}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
              <td mat-cell *matCellDef="let element"> {{element.address}} </td>
          </ng-container>


          <!-- Symbol Column -->
          <ng-container matColumnDef="houropen">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Hour Open </th>
              <td mat-cell *matCellDef="let element"> {{element.houropen}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="hourclose">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Hour Close </th>
              <td mat-cell *matCellDef="let element"> {{element.hourclose}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="typeuser">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
              <td mat-cell *matCellDef="let element"> {{element.typeuser}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
              <td mat-cell *matCellDef="let element">



                <span class="badge badge-pill badge-primary pilas" [ngStyle]="{'background-color':  getColorStatus(element.status)  }"> {{  statusOrder(element.status) }}</span>

              </td>
          </ng-container>


          <!-- Symbol Column -->
          <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
              <th mat-header-cell *matHeaderCellDef> Symbol </th>
              <td mat-cell *matCellDef="let element">

                  <button class="btn btn-primary" [disabled]="element.companyname=='No Company'" [routerLink]="['/editorder', element.id]"> <i class="fa fa-edit"></i></button>
                  <button class="btn btn-danger" (click)="deleteOrder(element)" style="margin-left:5px"> <i class="fa fa-remove"></i></button>
                  <button class="btn btn-success" [routerLink]="['/orderDetail', element.id]" style="margin-left:5px"> <i class="fa fa-eye"></i></button>
              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
  </div>
</div>
